import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "./copy-icon.m.css";

const CopyIcon = ({ fullUrl, bgColor, icon }) => {
  const [toolTip, setToolTip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setToolTip(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [toolTip]);

  const handleCopyClick = async () => {
    try {
      await window.navigator.clipboard.writeText(fullUrl);
      setToolTip(true);
    } catch (err) {
      console.error("Unable to copy to clipboard.", err);
    }
  };

  return (
    <>
      <div onClick={handleCopyClick} styleName="social-wrapper" style={{ background: bgColor }}>
        <div styleName="social-icon-wrapper">{icon}</div>
      </div>
      {toolTip && <span styleName="tooltip">Copied!</span>}
    </>
  );
};

CopyIcon.propTypes = {
  fullUrl: PropTypes.string,
  bgColor: PropTypes.string,
  icon: PropTypes.object,
};

export default CopyIcon;
